import { useSessionStorage } from "./useSessionStorage";
import { useState } from "react";
import actions from "../config.json";
import { getExperienceParams } from "../utils/experienceContext";

export const useBeverages = () => {
  const storageKey = "storage";
  const { setItem, getItem } = useSessionStorage("beverages", {
    key: storageKey,
    value: {
      Coffee: 0,
      Tea: 0,
      Milk: 0,
      Juice: 0,
      Smoothie: 0,
      Soda: 0,
      Water: 0,
      "Sparkling Water": 0,
      Mocktail: 0,
      Beer: 0,
      Wine: 0,
    },
  });
  const [beverages, setBeverages] = useState(getItem(storageKey));

  const tapBeverage = (beverage, maxTaps = 2) => {
    const value = { ...getItem(storageKey) };
    let taps = value[beverage] || 0;

    if (taps >= maxTaps) {
      taps = 0;
    } else {
      taps += 1;
    }

    value[beverage] = taps;
    setItem(storageKey, value);
    setBeverages(value);
    return taps;
  };

  const getBeverageValue = (beverage) => {
    return getItem(storageKey)[beverage] ?? 0;
  };

  const isAnyBeverageSelected = () => {
    return Object.entries(beverages).find(([, value]) => value > 0) != null;
  };

  const getSelectedBeveragesAsArray = () => {
    const beverages = getItem(storageKey);
    return Object.entries(beverages)
      .filter(([, value]) => value > 0)
      .map(([key, value]) => ({
        name: key,
        preference: value >= 2 ? "love" : "like",
      }));
  };

  const getSelectedBeveragesAsFlatArray = () => {
    const beverages = getItem(storageKey);
    return Object.entries(beverages)
      .filter(([, value]) => value > 0)
      .map(([key]) => key);
  };


  const saveBeveragesToServer = async (acid) => {
    const beverages = getItem(storageKey);

    const beveragePreferences = Object.entries(beverages)
      .filter(([, value]) => value > 0)
      .map(([key, value]) => ({
        beverage: key,
        level: value >= 2 ? "LOVE" : "LIKE",
      }));

    const actionUrl = actions["marriott-passions-v3/save-beverage-preferences"];

    try {
      const response = await fetch(`${actionUrl}`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          acid: acid,
          beveragePreferences: beveragePreferences,
          ...getExperienceParams(),
        }),
      });

      if (!response.ok) {
        throw new Error(`Failed to save beverage preferences: ${response.status}`);
      }

      return response;
    } catch (err) {
      console.error("Error saving beverage preferences:", err);
      throw err;
    }
  };

  return {
    tapBeverage,
    getBeverageValue,
    isAnyBeverageSelected,
    getSelectedBeveragesAsArray,
    getSelectedBeveragesAsFlatArray,
    saveBeveragesToServer,
  };
};
